export const CORE_PRODUCT_ID = 'prod-ruzuku';

export const CORE_INSTANT_COURSES_PRODUCT_ID = 'prod-bundles';

export const CALENDAR_PRODUCT_ID = 'prod-calendar';

export const FREE_CORE_PRICE_ID = 'price-ruzukutrial';
